import * as PIXI from 'pixi.js'
import { globalData } from './globalData';
import { changeRoundNumber, showManualPopup, updateTotalBet } from './gameUI';
import { playDisable, playMinus, playOff, playOn, playPlus } from './soundManager';
import { tweenFadeAppear } from './utility';

export class roundPanel {
    roundPanelContainer = null;
    roundIcon = null;
    betPanel = null;
    plusButtonNormal = null;
    minusButtonNormal = null;
    betValueText = null;
    roundIndex = 0
    roundValues = []
    enabled = true;
    betPanelOpen = false;

    plusBtnHitGraphic = null;
    minusBtnHitGraphic = null;

    constructor(x = 360, y = 675) {
        this.roundValues = globalData.roundSettings;
        console.log("round-panel", this.roundValues);
        this.roundPanelContainer = new PIXI.Container();
        this.roundPanelContainer.scale.set(1)
        this.roundIcon = new PIXI.Sprite(PIXI.Assets.get('rounds_panel'));
        this.roundIcon.anchor.set(0.5);
        this.roundIcon.scale.set(1);
        this.roundIcon.position.set(x, y);
        this.roundIcon.interactive = true;
        this.roundIcon.on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
                this.toggleBetPanel();
                event.stopPropagation();
            }
        });
        this.setupBetPanel();
        this.setupBetValueTextDisplay();
        this.roundPanelContainer.addChild(this.roundIcon);
        this.setupBetControler();
        console.log("round-panel-1", this.roundIndex);
        
        globalData.totalRounds = this.roundValues[this.roundIndex];
        console.log("round-panel-1", this.roundIndex, globalData.totalRounds);
        
    }

    setupBetPanel() {
        this.betPanel = new PIXI.Sprite(PIXI.Assets.get('rounds_select_panel'));
        this.betPanel.anchor.set(0.5, 1);
        this.betPanel.scale.set(1);
        this.betPanel.initialX = this.roundIcon.x
        this.betPanel.initialY = this.roundIcon.y + 100
        this.betPanel.finalX = this.roundIcon.x
        this.betPanel.finalY = this.roundIcon.y
        this.betPanel.position.set(this.betPanel.initialX, this.betPanel.initialY);
        this.betPanel.interactive = true;
        this.betPanel.visible = false;
        this.roundPanelContainer.addChild(this.betPanel);

        this.drawRoundPanelGraphics();
    }

    setupBetValueTextDisplay() {
        const style = new PIXI.TextStyle({
            dropShadow: false,
            dropShadowAngle: 0,
            dropShadowBlur: 0,
            dropShadowColor: 0,
            dropShadowDistance: 0,
            stroke: 0,
            strokeThickness: 2,
            fill: '#ffffff',
            fontFamily: 'Arial',
            fontSize: 45,
            fontWeight: '700',
            align: 'center'
        });

        this.betValueText = new PIXI.Text(this.roundValues[this.roundIndex], style);
        this.betValueText.y = 20;
        this.betValueText.x = 0
        this.betValueText.anchor.set(0.5);
        this.roundIcon.addChild(this.betValueText);
    }
    updateBetValueText(roundIndex = this.roundIndex) {
        this.betValueText.text = this.roundValues[roundIndex];
    }

    setupBetControler() {
        this.plusButtonNormal = new PIXI.Sprite(PIXI.Assets.get('plus_b_normal'));
        this.plusButtonNormal.anchor.set(0.5);
        this.plusButtonNormal.scale.set(1);
        this.plusButtonNormal.position.set(this.roundIcon.x + 155, this.roundIcon.y + 22)

        const plusButtonHover = new PIXI.Sprite(PIXI.Assets.get('plus_b_selected'));
        plusButtonHover.anchor.set(0.5);
        plusButtonHover.visible = false;
        this.plusButtonNormal.addChild(plusButtonHover);

        const plusButtonDown = new PIXI.Sprite(PIXI.Assets.get('plus_b_down'));
        plusButtonDown.anchor.set(0.5);
        plusButtonDown.visible = false;
        this.plusButtonNormal.addChild(plusButtonDown);

        const plusButtonDisabled = new PIXI.Sprite(PIXI.Assets.get('plus_b_disabled'));
        plusButtonDisabled.anchor.set(0.5);
        plusButtonDisabled.visible = false;
        this.plusButtonNormal.addChild(plusButtonDisabled);

        this.plusBtnHitGraphic = new PIXI.Graphics();
        this.plusBtnHitGraphic.beginFill(0x202020, 1);
        this.plusBtnHitGraphic.drawCircle(0, 0, 75);
        this.plusBtnHitGraphic.endFill();
        this.plusBtnHitGraphic.alpha = 0
        this.plusBtnHitGraphic.interactive = true;
        this.plusBtnHitGraphic.cursor = 'pointer'
        this.plusButtonNormal.addChild(this.plusBtnHitGraphic);

        this.minusButtonNormal = new PIXI.Sprite(PIXI.Assets.get('minus_b_normal'));
        this.minusButtonNormal.anchor.set(0.5);
        this.minusButtonNormal.scale.set(1);
        this.minusButtonNormal.position.set(this.roundIcon.x - 155, this.roundIcon.y + 22)
        // this.minusButtonNormal.interactive = true

        const minusButtonHover = new PIXI.Sprite(PIXI.Assets.get('minus_b_selected'));
        minusButtonHover.anchor.set(0.5);
        minusButtonHover.visible = false;
        this.minusButtonNormal.addChild(minusButtonHover);

        const minusButtonDown = new PIXI.Sprite(PIXI.Assets.get('minus_b_down'));
        minusButtonDown.anchor.set(0.5);
        minusButtonDown.visible = false;
        this.minusButtonNormal.addChild(minusButtonDown);

        const minusButtonDisabled = new PIXI.Sprite(PIXI.Assets.get('minus_b_disabled'));
        minusButtonDisabled.anchor.set(0.5);
        minusButtonDisabled.visible = false;
        this.minusButtonNormal.addChild(minusButtonDisabled);

        this.minusBtnHitGraphic = new PIXI.Graphics();
        this.minusBtnHitGraphic.beginFill(0x202020, 1);
        this.minusBtnHitGraphic.drawCircle(0, 0, 75);
        this.minusBtnHitGraphic.endFill();
        this.minusBtnHitGraphic.alpha = 0
        this.minusBtnHitGraphic.interactive = true;
        this.minusBtnHitGraphic.cursor = 'pointer'
        this.minusButtonNormal.addChild(this.minusBtnHitGraphic);

        this.plusBtnHitGraphic.on('pointerover', () => {
            plusButtonHover.visible = true;
        })
        this.plusBtnHitGraphic.on('pointerout', () => {
            plusButtonHover.visible = false;
        })
        this.plusBtnHitGraphic.on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
                if (globalData.totalRounds < this.roundValues[this.roundValues.length - 1]) {
                    this.roundIndex++;
                    globalData.totalRounds = this.roundValues[this.roundIndex];
                    this.betValueText.text = globalData.totalRounds;
                    plusButtonDown.visible = true;
                    // if (this.roundIndex === this.roundValues.length - 1) {
                    //   //  plusButtonDisabled.visible = true;
                    // }
                    // if (this.roundIndex > 0 && minusButtonDisabled.visible) {
                    //  //   minusButtonDisabled.visible = false
                    // }
                    // // globalData.totalRounds = this.roundValues[this.roundIndex];
                    changeRoundNumber();
                    updateTotalBet();
                    playPlus();
                }
                else {
                    playDisable();
                }
            }
        })

        this.plusBtnHitGraphic.on('pointerupoutside', () => {
            plusButtonDown.visible = false;
        });
        this.plusBtnHitGraphic.on('pointerup', () => {
            plusButtonDown.visible = false;
        })

        this.minusBtnHitGraphic.on('pointerover', () => {
            minusButtonHover.visible = true;
        })
        this.minusBtnHitGraphic.on('pointerout', () => {
            minusButtonHover.visible = false;
        })
        this.minusBtnHitGraphic.on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
                if (globalData.totalRounds > this.roundValues[0]) {
                    this.roundIndex--;
                    globalData.totalRounds = this.roundValues[this.roundIndex];
                    this.betValueText.text = globalData.totalRounds;
                    minusButtonDown.visible = true;
                    // if (this.roundIndex === 0) {
                    //     minusButtonDisabled.visible = true;
                    // }
                    // if (this.roundIndex < this.roundValues.length - 1 && plusButtonDisabled.visible) {
                    //     plusButtonDisabled.visible = false
                    // }
                    //  globalData.totalRounds = this.roundValues[this.roundIndex];
                    changeRoundNumber();
                    updateTotalBet();
                    playMinus();
                }
                else {
                    playDisable();
                }
            }
        })
        this.minusBtnHitGraphic.on('pointerupoutside', () => {
            minusButtonDown.visible = false;
        });
        this.minusBtnHitGraphic.on('pointerup', () => {
            minusButtonDown.visible = false;
        })

        this.roundPanelContainer.addChild(this.plusButtonNormal, this.minusButtonNormal);
    }


    setRoundValue(index) {
        console.log("set-round-value", globalData.totalRounds);
        
        this.updateBetValueText();
        //  this.minusButtonDown.visible = true;
        globalData.totalRounds = this.pannelBetArray[index];
        console.log("set-round-value", globalData.totalRounds);
        
        this.betValueText.text = this.pannelBetArray[index];
        updateTotalBet();
        changeRoundNumber();
        playPlus();
        this.roundIndex = index;
        this.toggleBetPanel();
    }

    buttonGraphics = []
    pannelBetArray = []
    drawRoundPanelGraphics() {
        const style = new PIXI.TextStyle({
            dropShadow: false,
            dropShadowAngle: 0,
            dropShadowBlur: 0,
            dropShadowColor: 0,
            dropShadowDistance: 0,
            stroke: 0,
            strokeThickness: 0,
            fill: '#ffffff',
            fontFamily: 'Arial',
            fontSize: 32,
            fontWeight: '700',
            align: 'center'
        });

        let i = 0;
        this.pannelBetArray = globalData.roundSettings;
        for (let row = 0; row < Math.ceil(this.roundValues.length / 2); row++) {
            for (let column = 0; column < 3 && i < this.roundValues.length; column++) {

                this.buttonGraphics[i] = new PIXI.Graphics();
                this.buttonGraphics[i].beginFill(0xffffff, 0.01);
                this.buttonGraphics[i].drawRoundedRect(column * 82 - this.betPanel.width / 2 + 28, 10 - this.betPanel.height + row * 65, 80, 60, 10);
                this.buttonGraphics[i].endFill();
                this.buttonGraphics[i].interactive = true;
                this.betPanel.addChild(this.buttonGraphics[i]);

                const panelBetValueText = new PIXI.Text(this.pannelBetArray[i], style);
                panelBetValueText.x = column * 82 - this.betPanel.width / 2 + 70;
                panelBetValueText.y = 10 - this.betPanel.height + row * 50 + 45
                panelBetValueText.anchor.set(0.5);
                this.buttonGraphics[i].addChild(panelBetValueText);

                this.buttonGraphics[i].on('pointerdown', (event) => {
                    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
                        var self = event.currentTarget
                        var index = this.buttonGraphics.indexOf(self)
                        this.setRoundValue(index);
                    }
                });


                if (i < 15)
                    i++
            }
        }
    }

    disablePanel() {
        this.plusBtnHitGraphic.interactive = false;
        this.minusBtnHitGraphic.interactive = false;
        this.roundIcon.interactive = false;
        this.betValueText.style.fill = 0x959595
        this.plusButtonNormal.children[2].visible = true;
        this.minusButtonNormal.children[2].visible = true;
        this.enabled = false;
    }
    enablePanel() {
        this.plusBtnHitGraphic.interactive = true;
        this.minusBtnHitGraphic.interactive = true;
        this.roundIcon.interactive = true;
        this.betValueText.style.fill = 0xffffff;
        this.plusButtonNormal.children[2].visible = false;
        this.minusButtonNormal.children[2].visible = false;

        // if (this.roundIndex === this.roundValues.length - 1) {
        //     this.plusButtonNormal.children[2].visible = true;
        // }
        // if (this.roundIndex === 0) {
        //     this.minusButtonNormal.children[2].visible = true;
        // }
        this.enabled = true;
    }

    toggleBetPanel() {
        if (this.betPanel.visible) {
            tweenFadeAppear(this.betPanel, false)
            playOff()
        }
        else {
            tweenFadeAppear(this.betPanel, true)
            playOn()
        }
    }

    // update(dt) {
    //     if (this.betPanel.scale.y <= 1 && !this.betPanelOpen) {
    //         this.betPanel.scale.y = dt * 0.5;
    //         if (this.betPanel.scale.y == 1 && !this.betPanelOpen) {
    //             this.betPanel.scale.y = 1;
    //             this.betPanelOpen = true;
    //         }
    //     }
    // }

}